(function ($, w) {
	var $w = $(w);
	$(function () {
		$(".owl-carousel").owlCarousel({
			loop: true,
			autoplay: true,
			autoplayTimeout: 3000,
			lazyLoad: true,
			items: ($w.width() <= 640 ? 4 : 6)
		});
	});
})(jQuery, window);